<template>
  <transition
    appear
    name="fade"
  >
    <div class="single-card-tracking">
      <b-row
        class="single-card float-component mb-3"
        :class="{'card-active': isChecked}"
      >
        <b-col
          cols="auto"
          class="d-flex align-items-center"
          @click="selectorCheck()"
        >
          <div
            class="tr-btn d-flex align-items-center justify-content-center"
            :class="{'active': isChecked}"
          >
            <i
              v-show="isChecked"
              class="fal fa-check"
              aria-hidden="true"
            />
          </div>
        </b-col>
        <b-col
          class="main-info d-flex pl-2"
          md="3"
          sm="6"
          @click="select()"
        >
          <div
            style="width: 40px"
            class="d-flex align-items-center justify-content-center"
            :class="{'depleted':information.depleted}"
          >
            <img
              v-if="type === 'portion' && information.portionTypeEnum !== portionTypes.FROZEN_BLOCK.key"
              src="@/img/block-tr.png"
              alt="block-icon"
              class="block-icon"
              aria-hidden="true"
            >
            <img
              v-if="type === 'subportion'"
              src="@/img/porta-tr.png"
              alt="porta-icon"
            >
            <img
              v-if="information.portionTypeEnum === portionTypes.FROZEN_BLOCK.key"
              src="@/img/frozen-block-tr.png"
              class="block-icon"
              alt="porta-icon"
              aria-hidden="true"
            >
          </div>
          <div class="text-section d-flex flex-column justify-content-center ml-3">
            <span
              class="card-label primary-dark-color font-weight--medium"
              qa="single-card-tracking-label"
            >{{ externalId }}</span>
            <span
              class="card-text label-dark"
              qa="single-card-tracking-location"
            >{{ location }}</span>
          </div>
        </b-col>
        <b-col
          class="main-info d-flex pl-2"
          md="3"
          sm="4"
          @click="select()"
        >
          <div class="text-section d-flex flex-column justify-content-center ml-3">
            <span
              v-if="type === 'subportion'"
              class="card-label primary-dark-color"
              qa="single-card-tracking-assay-name"
            >{{ information.assay ? information.assay.name : '' }}</span>
            <span
              v-if="type === 'portion'"
              class="card-label primary-dark-color"
              qa="single-card-tracking-sample-type"
            >{{ information.sample.sampleType.description }}</span>
            <span
              class="card-text label-dark"
              :class="{'empty-text': !information.taskDevice}"
              qa="single-card-tracking-device"
            >{{ information.taskDevice ? information.taskDevice.device : '' }}</span>
          </div>
        </b-col>
        <b-col
          v-if="type === 'portion'"
          class="main-info d-flex pl-2 mt-sm-3 mt-md-0"
          md="3"
          sm="3"
          @click="select()"
        >
          <div class="text-section d-flex flex-column justify-content-center ml-3">
            <span
              class="card-label primary-dark-color"
              qa="single-card-tracking-portion-fragments"
            >
              {{ $t('laboratory.tracking.fragmentsNumber') }}: {{ information.porFragments ? information.porFragments : '-' }}</span>
            <span
              class="card-text label-dark"
              :class="{'empty-text': !information.fragmentOrientation}"
              qa="single-card-tracking-portion-orientation"
            >
              <i
                v-tooltip="$t('laboratory.tracking.orientation')"
                :class="information.fragmentOrientation ? information.fragmentOrientation.forIconName : ''"
                aria-hidden="true"
              />
              {{ information.fragmentOrientation ? information.fragmentOrientation.forDescription : $t('laboratory.tracking.noOrientation') }}
            </span>
          </div>
        </b-col>
        <b-col
          class="main-info d-flex align-items-center justify-content-end pl-2"
          :class="{'cols-6':type === 'subportion', 'cols-3':type === 'portion'}"
          @click.self="select()"
        >
          <vtBubble
            v-if="information.incidentsCount"
            v-testing="'incidents'"
            :number="information.incidentsCount"
            :type="true"
            :tooltip="' '+$t('grid.detail.hasAlarms')"
            class="mr-2"
            @click="openIncidentsModal"
          />
          <vtBubble
            v-if="information.attachmentsCount"
            v-testing="'attachments'"
            :number="information.attachmentsCount"
            :type="false"
            :tooltip="' '+$t('grid.attachments')"
            class="mr-2"
            @click="openAttachmentsListModal"
          />
          <!-- TODO: Next div and icons are prepared for external control development, need to show only if subportion entity: v-if="type === 'subportion'" -->
          <div
            v-if="false"
            class="external-control-icons"
          >
            <span
              v-tooltip.html="`${$tc('global.externalControlRequired')}:<br>${$tc('configuration.grid.controlTypeTissueControl')}`"
              class="icon-control-required mx-2 alt-color"
              qa="single-card-tracking-external-control-required"
            />
            <span
              v-if="false"
              v-tooltip="$tc('global.noExternalControl')"
              class="icon-control-slash mr-1 alt-color"
              qa="single-card-tracking-no-external-control"
            />
            <span
              v-if="false"
              v-tooltip.html="`${$tc('global.externalControlOptional')}:<br>${$tc('configuration.grid.controlTypeTissueControl')}`"
              class="icon-control-optional-true mr-1 alt-color"
              qa="single-card-tracking-external-control-optional-true"
            />
            <span
              v-if="false"
              v-tooltip.html="`${$tc('global.externalControlOptional')} ${$tc('global.externalControlUnmarked')}:<br>${$tc('configuration.grid.controlTypeTissueControl')}`"
              class="icon-control-optional-false mr-1 alt-color"
              qa="single-card-tracking-external-control-optional-false"
            />
            <span
              v-if="false"
              v-tooltip.html="`${$tc('global.externalControlOnDemand')}:<br>${$tc('configuration.grid.controlTypeTissueControl')}`"
              class="icon-control-on-demand-true mr-1 alt-color"
              qa="single-card-tracking-external-control-on-demand-true"
            />
            <span
              v-if="false"
              v-tooltip.html="`${$tc('global.externalControlOnDemand')} ${$tc('global.externalControlUnmarked')}:<br>${$tc('configuration.grid.controlTypeTissueControl')}`"
              class="icon-control-on-demand-false mr-1 alt-color"
              qa="single-card-tracking-external-control-on-demand-false"
            />
          </div>
          <div
            v-if="information.requester"
            class="profile-img mr-2"
            qa="single-card-tracking-requester-profile-image"
          >
            <vt-personnel-profile-image
              :personnel-id="information.requester.id"
              :cancel-token="userProfileImageCancelToken"
              :img-tooltip="`${$tc('global.petitioner')}<br/>${information.requester.fullName}`"
              img-class="img-fluid"
            />
          </div>

          <div
            v-if="pathologist"
            class="profile-img mr-2"
            qa="single-card-tracking-pathologist-profile-image"
          >
            <vt-personnel-profile-image
              :personnel-id="pathologist.id"
              :cancel-token="userProfileImageCancelToken"
              :img-tooltip="`${$tc('grid.detail.patName')}<br/>${pathologist.fullName}`"
              img-class="img-fluid"
            />
          </div>

          <study-request-priority-dot
            v-if="type === 'subportion'"
            class="mx-2"
            :priority="information.priority"
            :size="12"
            qa="single-card-tracking-priority"
          />
          <i
            v-if="visibleHasUnauthorizedBillableConceptsIcon(information.hasUnauthorizedBillableConcepts)"
            v-tooltip="$t('global.hasUnauthorizedBillableConcepts')"
            aria-hidden="true"
            class="mx-2 fas fa-calculator danger-color"
          />
          <span
            v-if="information.hasUnfinishedReview"
            v-b-tooltip.hover="{ title: $tc('diagnosis.labels.pendingReview', 1) }"
            class="far fa-tasks review-icon pending ml-2 mr-3"
            qa="single-card-tracking-review-pending"
            @click="onShowReviewInfoModal"
          />
          <span
            v-if="information.observations"
            v-b-tooltip.hover="{ title: $tc('laboratory.tracking.elementWithObservations') }"
            class="fas fa-comment-lines info-icon alt-primary ml-1 mr-2"
            qa="single-card-tracking-observations"
            @click="$emit('showMoreInfoModal', information)"
          />
          <!-- TODO: Front development required -->
          <span
            v-if="false"
            v-tooltip.html="`${$tc('laboratory.grid.lastSubportionCutDate')}:<br>00-00-0000 00:00`"
            class="far fa-cut info-icon alt-primary ml-1 mr-2"
          />
          <span
            class="fal fa-info-circle info-icon main"
            qa="single-card-tracking-more-info"
            @click="$emit('showMoreInfoModal', information)"
          />
        </b-col>
      </b-row>
      <modal-cut
        v-if="loadModal"
        id="cutModal"
        ref="cutModal"
        :portion="information"
        :external-id="externalId"
        :location="location"
        @incidentAdded="onModalCutIncidentAdded"
        @allPendingCutSubportionsCancelled="onModalCutAllPendingCutSubportionsCancelled"
        @onHide="onHide"
        @actionApplied="$emit('updateContent')"
      />
      <modal-wrapper ref="reviewInfoModalWrapper">
        <review-info-modal
          :laboratory-id="labId"
          :case-id="caseId"
        />
      </modal-wrapper>
    </div>
  </transition>
</template>

<script>
import ModalCut from '@/modules/laboratoryModule/laboratoryTracking/modals/ModalCut'
import StudyRequestPriorityDot from '@/modules/clinicalModule/components/StatusRequestPriorityDot'
import VtBubble from '@/components/common/VtBubble'
import LaboratoryOptionGuardsMixin from '@/modules/laboratoryModule/mixins/LaboratoryOptionGuardsMixin'
import LABORATORY_OPERATIONS from '@/modules/laboratoryModule/config/operations'
import { ENTITIES_LABORATORY } from '@/modules/laboratoryModule/config/sidebarConfig'
import { PORTION_TYPES } from '@/api/resources/portionTypeService'
import { ReviewHelper } from '@/modules/laboratoryModule/common/review-helper'
import ReviewInfoModal from '@/modules/diagnosisModule/views/form/modals/reviewModal/ReviewInfoModal'
import { ModuleOperationGuard } from '@/api/operations/guards/module-operation-guard'

export default {
    name: 'SingleCardTracking',
    components: {
        ModalCut,
        ReviewInfoModal,
        StudyRequestPriorityDot,
        VtBubble
    },
    mixins: [
        LaboratoryOptionGuardsMixin
    ],
    props: {
        labId: Number,
        type: String,
        information: Object,
        userProfileImageCancelToken: Object
    },
    data() {
        return {
            isChecked: false,
            loadModal: false,
            portionTypes: PORTION_TYPES
        }
    },
    computed: {
        pathologist() {
            return this.type === ENTITIES_LABORATORY.PORTION
                ? this.information?.sample.caseStudy.pathologist
                : this.information?.portion?.sample.caseStudy.pathologist
        },
        externalId() {
            return this.type === ENTITIES_LABORATORY.PORTION
                ? this.information?.porLabel
                : this.information?.supLabel
        },
        location() {
            return this.type === ENTITIES_LABORATORY.PORTION
                ? this.information?.sample.topographicCode.description
                : this.information?.portion?.sample.topographicCode.description
        },
        userLastProfileImage() {
            return this.$store.getters.userLastProfileImage
        },
        caseId() {
            return this.type === ENTITIES_LABORATORY.PORTION
                ? this.information?.sample.caseStudy.casId
                : this.information?.portion?.sample.caseStudy.casId
        }
    },
    watch: {
        information() {
            this.isChecked = this.information?.checked
            this.$emit('select', this.information)
        }
    },
    mounted() {
        this.isChecked = this.information?.checked
        this.$emit('select', this.information)
    },
    methods: {
        visibleHasUnauthorizedBillableConceptsIcon(hasUnauthorizedBillableConcepts) {
            return ModuleOperationGuard.canAccessBilling && hasUnauthorizedBillableConcepts
        },
        onModalCutIncidentAdded() {
            this.$emit('updateList')
        },
        onModalCutAllPendingCutSubportionsCancelled() {
            setTimeout(() => {
                this.$emit('updateList')
            }, 2000)
        },
        openIncidentsModal() {
            const type = this.selectedOption.typeAlt || this.selectedOption.type
            const entitiesIds = type === ENTITIES_LABORATORY.PORTION ? [
                this.information.sample.caseStudy.casId,
                this.information.sample.samId,
                this.information.porId
            ] : [
                this.information.portion.sample.caseStudy.casId,
                this.information.portion.sample.samId,
                this.information.portion.porId,
                this.information.supId
            ]
            this.$emit('openIncidentsModal', { entitiesIds: entitiesIds, information: this.information })
        },
        openAttachmentsListModal() {
            this.$emit('openAttachmentsListModal', this.information)
        },
        onHide() {
            this.isChecked = false
            this.loadModal = false
            this.information.checked = false
        },
        showCutModal() {
            this.loadModal = true
            this.$nextTick(() => {
                this.$refs.cutModal.show()
            })
        },
        select() {
            if (this.selectedOption.operation === LABORATORY_OPERATIONS.PARAFFINBLOCK_CUT.id) {
                this.showCutModal()
            } else {
                this.selectorCheck()
            }
            this.$emit('select', this.information)
        },
        selectorCheck() {
            this.isChecked = !this.isChecked
            this.information.checked = !this.information.checked
            this.$emit('select', this.information)
        },
        async onShowReviewInfoModal() {
            const reviewInfo = await ReviewHelper.mapReviewInfo(this.labId, this.information, this.type)
            this.$refs.reviewInfoModalWrapper.show([reviewInfo.revision, reviewInfo.entity, reviewInfo.entityType])
        }
    }
}
</script>

<style lang="scss">
.single-card-tracking {
    .vtbubble {
        margin-left: 0 !important;
    }
}

.single-card-tracking .depleted::before {
  content: '';
  position: absolute;
  background: vt-color(primary);
  width: 45px;
  height: 2px;
  transform: rotate(-45deg);
}

.single-card-tracking .sidepanel {
  position: absolute;
  background: white;
  right: 0;
  top: 0;
  width: 300px;
  height: 300px;
}

.single-card-tracking .single-card,
.cut-card-tracking .single-card {
    padding: 10px 0;
    .external-control-icons {
        font-size: font-size-type(font-size-big-3);
    }
}

.single-card-tracking .card-label,
.cut-card-tracking .card-label {
    font-size: font-size(normal);
}

.single-card-tracking .card-text {
    color: vt-color(dark-text);
    font-size: font-size(very-small);
    margin-top: 5px;
}

.single-card-tracking .empty-text,
.cut-card-tracking .empty-text {
    opacity: .6;
    font-style: italic;
}

.single-card-tracking .profile-img,
.cut-card-tracking .profile-img {
    width: 23px;
    height: 23px;
}

.single-card-tracking .profile-img img,
.cut-card-tracking .profile-img img, {
    width: 100% !important;
    height: auto !important;
    border-radius: 50%;
}

.single-card-tracking .vtbubble {
  width: 23px !important;
  height: 23px !important;
}

.single-card-tracking .flagdot i {
  font-size: 18px;
}

.single-card-tracking .showtooltip {
  display: block;
}

.single-card-tracking .noshowtooltip {
  display: none;
}
</style>

<style lang="scss" scoped>
.single-card-tracking .orientation i::before {
  margin-left: 0;
}

.single-card-tracking .single-card {
  border-radius: 1rem;
}

.single-card-tracking .date {
  color: vt-color(dark-text);
  margin-top: 3px;
}

.single-card-tracking .single-card.card-active {
  @include general-card($color: vt-color(green-radiant));
  border-radius: 1rem;
  transition: all .1s ease-in-out;
}

.single-card-tracking .tr-btn {
  border-radius: 50%;
  width: 35px;
  height: 35px;
  background: #fff;
  border: 1px solid #d8d8d8;
  color: grey;
  transition: all .1s ease-in-out;
}

.single-card-tracking .tr-btn.active {
  background: #2ecc71;
  color: #fff;
  transition: all .1s ease-in-out;
}

.single-card-tracking .main-info {
  cursor: pointer;
}

.single-card-tracking .main-info img {
  width: 35px;
}

/*.single-card-tracking .main-info span {
  color: vt-color(primary);
  font-size: font-size(normal);
}*/

/*.single-card-tracking .main-info small {
  font-size: 11px;
}*/

.single-card-tracking .main-info .flex-column {
  line-height: 12px;
}

.single-card-tracking h4 {
  font-weight: normal;
  font-size: font-size(small);
  width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.single-card-tracking .observations {
  width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.single-card-tracking .buttons {
  font-size: 20px;
  color: #2ecc71;
}

.single-card-tracking .info-icon {
  font-size: 22px;
}

.single-card-tracking .review-icon {
    font-size: 18px;
    &.pending {
        color: vt-color(dark-orange);
    }
    &.completed {
        color: vt-color(spring-green);
    }
}

.single-card-tracking .block-icon {
  width: 25px !important;
}
</style>
